import { Typography } from '@cobliteam/ui/components';

interface SummaryRowProps {
  label: string;
  value: string;
  /** Renders the bottom border. Disabled on the last row by the caller. */
  withDivider?: boolean;
}

/**
 * Single label/value row in the confirm-step summary card. The list is intentionally read-only;
 * editing happens on the alerts page via the "Editar alerta" link.
 */
const SummaryRow = ({ label, value, withDivider = true }: SummaryRowProps) => (
  <div className={`flex items-center gap-3 px-4 py-3 ${withDivider ? 'border-gray-6 border-b' : ''}`}>
    <Typography variant='text-sm' color='secondary' className='shrink-0'>
      {label}
    </Typography>
    <Typography variant='text-sm-medium' className='text-right'>
      {value}
    </Typography>
  </div>
);

export default SummaryRow;
export type { SummaryRowProps };
